import { Injectable, inject } from '@angular/core';
import { WINDOW_TOKEN } from '../tokens/app-tokens';

@Injectable({
  providedIn: 'root',
})
export class RouteCheckerService {
  readonly WN_LOGOUT_REDIRECTOR = '/wn-logout-redirector';
  private readonly window = inject(WINDOW_TOKEN);
  private readonly PUBLIC_ROUTES = [this.WN_LOGOUT_REDIRECTOR];
  private readonly THEFT_PROTECTION_ALARM_ROUTE = '/theft-protection-alarm';

  isPublicRoute(): boolean {
    return this.PUBLIC_ROUTES.includes(this.window.location.pathname);
  }

  isTheftProtectionAlarmRoute(): boolean {
    return this.window.location.pathname?.startsWith(this.THEFT_PROTECTION_ALARM_ROUTE);
  }
}
